<template>
  <div class="page-wrap" v-if="!invite">
    <div class="mobile-screen" v-if="platform == 'mobile'">
      <template v-if="$route.query.type == 1">
        <div class="luck">
          <img src="../../static/img/h5_success.png" alt="" />恭喜您领到{{
            $route.query.companyName
          }}专属优惠券
        </div>
        <div class="in-account">优惠券已放入您账户{{ phone }}</div>
        <div class="coupon-info">
          <div class="coupon-nav">
            <div class="info-container">
              <div class="info-left">
                <span>{{ $route.query.discount_rate }}</span
                >折
              </div>
              <div class="info-right">
                <div class="type">
                  <div class="text">{{ $route.query.companyName }}</div>
                  <div>专享</div>
                </div>
                <p class="date">全场通用 无限制使用</p>
              </div>
            </div>
          </div>
        </div>
      </template>
      <template v-else>
        <div class="luck">
          <img
            src="../../static/img/h5_success.png"
            alt=""
          />恭喜您成功领取优惠!
        </div>
        <div class="in-account">优惠券已放入您账户{{ phone }}</div>
        <div class="check">
          使用该手机号登录熊猫签证App到“我的-优惠券”中查看使用详情。
        </div>
        <div class="coupon-info">
          <div class="coupon-nav">
            <div class="info-container" v-if="$route.query.type == 3">
              <div class="info-left">
                ￥<span>{{ this.$route.query.cash_reduce }}</span>
              </div>
              <div class="info-right">
                <p class="type">{{ $route.query.reachReduceDec }}</p>
                <p class="date" v-if="$route.query.validity_type == 1">
                  领取后{{ $route.query.validity }}天内有效
                </p>
                <p class="date" v-else>
                  {{ $route.query.start_date }} 至 {{ $route.query.end_date }}
                </p>
              </div>
            </div>
            <div class="info-container" v-if="$route.query.type == 0">
              <div class="info-left">
                <span>{{ $route.query.discount_rate }}</span
                >折
              </div>
              <div class="info-right">
                <p class="type">{{ $route.query.reachReduceDec }}</p>
                <p class="date" v-if="$route.query.validity_type == 1">
                  领取后{{ $route.query.validity }}天内有效
                </p>
                <p class="date" v-else>
                  {{ $route.query.start_date }} 至 {{ $route.query.end_date }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </template>
      <button class="use" @click="openH5()">立即使用</button>
    </div>

    <div class="pc-screen" v-if="platform == 'pc'">
      <div class="main">
        <div class="header"></div>
        <p v-if="companyName">恭喜！成功领取{{ companyName }}专属优惠券</p>
        <p v-else>
          恭喜！成功领取
          <span>{{
            $route.query.type === 3
              ? `￥${this.$route.query.cash_reduce}`
              : `${$route.query.discount_rate}折`
          }}</span>
          优惠券
        </p>
        <p>扫描二维码下载App即可使用</p>
        <img src="../../static/img/invite/qrcode.png" alt="" width="200" />
        <div class="footer">
          粤ICP备15048723号-2<br />
          Copyright© 熊猫签证 2016-2017，版权所有
        </div>
      </div>
    </div>
  </div>

  <div class="invite" v-else>
    <div class="mobile-screen" v-if="platform == 'mobile'">
      <img src="../../static/img/invite/success.png" alt="" />
      <p v-if="companyName">恭喜！成功领取{{ companyName }}专属优惠券</p>
      <p v-else>
        恭喜！成功领取
        <span
          >￥<span>{{ maxReduce / 100 }}</span></span
        >
        优惠券
      </p>
      <div class="open-h5" @click="openH5">打开熊猫签证</div>
      <button v-if="ua.qq || ua.wx" @click="goDownload()">
        下载熊猫签证App
      </button>
    </div>

    <div class="pc-screen" v-if="platform == 'pc'">
      <div class="main">
        <div class="header"></div>
        <p v-if="companyName">恭喜！成功领取{{ companyName }}专属优惠券</p>
        <p v-else>
          恭喜！成功领取
          <span
            >￥<span>{{ maxReduce / 100 }}</span></span
          >
          优惠券
        </p>
        <p>扫描二维码下载App即可使用</p>
        <img src="../../static/img/invite/qrcode.png" alt="" width="200" />
        <div class="footer">
          粤ICP备15048723号-2<br />
          Copyright© 熊猫签证 2016-2017，版权所有
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import utils from '../services/tools.js';
import env from '../services/dev.js';

export default {
  data() {
    return {
      ua: utils.getFullUA(),
      platform: utils.getPlatform(),
      companyName: this.$route.query.companyName, // 从企业优惠券过来，就有这个属性
      maxReduce: this.$route.query.maxReduce || this.$route.query.cash_reduce, // 从普通优惠券和邀请过来就有这个属性
      invite: this.$route.query.invite, // 是否来自邀请
      phone: utils.phoneFormate(this.$route.query.mobilePhone),
    };
  },

  methods: {
    goDownload: utils.goDownload.bind(utils),

    openH5() {
      MtaH5.clickStat('open_pdv_h5');
      location.href = `https://${env}m.11visa.com/`;
    },
  },

  created() {
    if (this.invite) {
      utils.setTitle('新人大礼领取成功!');
    } else {
      utils.setTitle('优惠大礼领取成功!');
    }
  },

  beforeDestroy() {
    if (this.timer) {
      clearTimeout(this.timer);
    }
  },
};
</script>

<style lang="less" scoped>
@import '../styles/theme.less';

* {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}

.page-wrap {
  height: 100%;
  letter-spacing: 0.0015rem;
  background-color: white;
  text-align: center;
}

.mobile-screen {
  min-height: 100%;
  padding-top: 0.5rem;
  text-align: left;
  .luck {
    display: flex;
    justify-content: center;
    align-items: center;
    img {
      width: 0.18rem;
      height: 0.18rem;
      margin-right: 0.05rem;
    }
    font-size: 0.16rem;
    color: #444;
    text-align: center;
  }
  .in-account,
  .check {
    font-size: 0.12rem;
    color: #aaaaaa;
    line-height: 0.2rem;
    text-align: center;
    width: 2.7rem;
    margin: auto;
  }
  .in-account {
    margin-top: 0.15rem;
  }
  .coupon-info {
    background: url('../../static/img/coupon-bg.png') no-repeat;
    background-size: 100% 100%;
    height: 1.1rem;
    position: relative;
    width: 3.4rem;
    margin: auto;
    margin-top: 0.1rem;
    .coupon-nav {
      position: absolute;
      bottom: -0.08rem;
      padding: 0.04rem;
      background: #fff;
      border-radius: 0.06rem;
      box-shadow: 0px 2px 16px 0px rgba(0, 0, 0, 0.04);
      left: 50%;
      transform: translateX(-50%);
      .info-container {
        background: url(../../static/img/h5_border.png) no-repeat #fff;
        background-size: 100% 100%;
        display: flex;
        height: 0.9rem;
        width: 2.85rem;
        justify-content: center;
        align-items: center;
        .info-left {
          font-size: 0.16rem;
          color: #ff5a60;
          width: 0.9rem;
          flex-shrink: 0;
          text-align: center;
          span {
            font-size: 0.32rem;
          }
        }
        .info-right {
          width: 100%;
          p {
            margin: 0;
          }
          .type {
            color: #444444;
            font-size: 0.15rem;
            display: flex;
            .text {
              max-width: 1.2rem;
              text-overflow: ellipsis;
              overflow: hidden;
              word-break: keep-all;
            }
          }
          .date {
            color: #aaaaaa;
            font-size: 0.12rem;
            margin-top: 0.1rem;
          }
        }
      }
    }
  }
  .use {
    width: 2.4rem;
    height: 0.45rem;
    background-image: linear-gradient(-20deg, #ff455a 0%, #ff6653 100%),
      linear-gradient(#ff5a60, #ff5a60);
    background-blend-mode: normal, normal;
    box-shadow: 0px 8px 20px 0px rgba(255, 90, 96, 0.2);
    border-radius: 0.225rem;
    text-align: center;
    margin: auto;
    display: block;
    margin-top: 0.4rem;
  }

  p {
    color: #444;
    font-size: 0.16rem;
    margin-top: 0.15rem;

    & + p {
      margin-top: 0.1rem;
    }

    & > span {
      color: @red;

      span {
        font-size: 0.28rem;
      }
    }
  }

  .open-h5 {
    width: 2.6rem;
    height: 0.45rem;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #ff5a60;
    border: 1px solid #ff5a60;
    border-radius: 6px;
    margin: 0.2rem auto 0 auto;
  }

  button {
    width: 2.6rem;
    height: 0.45rem;
    border-radius: 6px;
    border: none;
    font-size: 0.16rem;
    color: white;
    margin: 0.15rem auto;
    background-image: linear-gradient(
      -20deg,
      rgba(255, 69, 90, 1) 0%,
      rgba(255, 102, 83, 1) 100%
    );
    box-shadow: 6.4px 7.7px 30px 0px rgba(255, 90, 96, 0.3);
  }
}

.invite {
  background-color: #fff;
  height: 100%;
  .mobile-screen {
    text-align: center;
    overflow: hidden;
    padding-top: 0rem;
    img {
      width: 1.9rem;
      margin: 0.4rem auto 0;
      display: block;
    }
    p {
      color: #444;
      font-size: 0.16rem;
      font-weight: 600;
      margin-top: 0.15rem;
      text-align: center;
    }
  }
  .pc-screen {
    p {
      text-align: center;
    }
  }
}

.pc-screen {
  background-color: #f3f4f6;
  min-height: 100%;
  // padding-top: 132px;
  position: relative;
  // padding-bottom: 80px;

  .main {
    width: 640px;
    margin: 0 auto;
    border-radius: 4px;
    background-color: white;
    overflow: hidden;
    height: 100%;
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    top: 0px;
  }

  .footer {
    font-size: 0.12rem;
    text-align: center;
    color: #aaa;
    bottom: 20px;
    padding-top: 0.35rem;
    margin: 0 auto;
  }

  .header {
    background: @red url(../../static/img/invite/banner-pc.jpg) no-repeat center
      bottom;
    background-size: contain;
    position: relative;
    height: 140px;
  }

  img {
    margin: 50px auto 0 auto;
    display: block;
  }

  p {
    color: #333;
    font-size: 0.24rem;
    margin-top: 60px;
    margin-bottom: 0.28rem;

    & + p {
      margin-top: 12px;
    }

    & > span {
      color: @red;
      font-weight: 600;

      span {
        font-size: 32px;
      }
    }
  }

  button {
    width: 2.6rem;
    height: 0.45rem;
    border-radius: 1rem;
    border: none;
    font-size: 0.16rem;
    color: white;
    margin: 0.25rem auto;
    background-image: linear-gradient(
      -20deg,
      rgba(255, 69, 90, 1) 0%,
      rgba(255, 102, 83, 1) 100%
    );
    box-shadow: 6.4px 7.7px 30px 0px rgba(255, 90, 96, 0.3);
  }
}
</style>
